module.exports = __webpack_public_path__ + "img/floor_f18_02.6c7e565b.png";